import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { Logo } from './Logo';
import { CONTACT } from '../data/modalities';
export function Footer() {
  return <footer className="border-t border-white/10 bg-navy text-white" data-id="element-299" data-mp="32ovvcp86ejhi">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:px-8 lg:grid-cols-[1.4fr_1fr_1fr]" data-id="element-300" data-mp="36p6bgupomqa3">
        <div data-id="element-301" data-mp="3ueik9th3kwbv">
          <Logo variant="light" data-id="element-302" data-mp="3uesbtlhsjbjo" />
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/75" data-id="element-303" data-mp="3uftmhouw9w0v">
            A consultative partner helping practices compare, select, train on,
            and implement therapeutic technologies across the United States.
          </p>
        </div>
        <div data-id="element-304" data-mp="3qcniyoz62iy3">
          <h3 className="text-[11px] font-semibold uppercase tracking-[0.18em] text-teal-light" data-id="element-305" data-mp="3qc41f9dfhwkl">
            Explore
          </h3>
          <ul className="mt-4 space-y-2.5 text-sm text-white/80" data-id="element-306" data-mp="2a19v9qy5pwze">
            <li data-id="element-307" data-mp="2ez1l8ff8r90y">
              <Link to="/#products" className="transition-colors hover:text-teal-light" data-id="element-308" data-mp="2ezl3xycpu1g1">
                Products
              </Link>
            </li>
            <li data-id="element-309" data-mp="3gca7d7ohu1db">
              <Link to="/#product-of-the-month" className="transition-colors hover:text-teal-light" data-id="element-310" data-mp="3gcjw6rxsy2hf">
                Product of the Month
              </Link>
            </li>
            <li data-id="element-311" data-mp="82qrjqil5pso">
              <Link to="/#concierge" className="transition-colors hover:text-teal-light" data-id="element-312" data-mp="828ni7pom7a7">
                Concierge Suite
              </Link>
            </li>
            <li data-id="element-313" data-mp="ht3d9m24zp0e">
              <Link to="/#used-equipment" className="transition-colors hover:text-teal-light" data-id="element-314" data-mp="hrihxu80021h">
                Used Equipment
              </Link>
            </li>
            <li data-id="element-315" data-mp="qu1jmb01s8m5">
              <Link to="/about" className="transition-colors hover:text-teal-light" data-id="element-316" data-mp="qrfboa98vr3e">
                About
              </Link>
            </li>
            <li data-id="element-317" data-mp="twxqz8ok588s">
              <Link to="/contact" className="transition-colors hover:text-teal-light" data-id="element-318" data-mp="tta2inxyzc0x">
                Contact
              </Link>
            </li>
          </ul>
        </div>
        <div data-id="element-319" data-mp="18kiw184zthjc">
          <h3 className="text-[11px] font-semibold uppercase tracking-[0.18em] text-teal-light" data-id="element-320" data-mp="18k92xboniu9f">
            Contact
          </h3>
          <ul className="mt-4 space-y-3 text-sm text-white/80" data-id="element-321" data-mp="1clckc2mckycr">
            <li data-id="element-322" data-mp="1hjw7258rme66">
              <a href={CONTACT.phoneHref} className="flex items-center gap-2.5 transition-colors hover:text-teal-light" data-id="element-323" data-mp="1hje1gi07qnll">
                <PhoneIcon className="h-4 w-4 text-teal-light" data-id="element-324" data-mp="1rjenwctdpju0" />
                {CONTACT.phone}
              </a>
            </li>
            <li data-id="element-325" data-mp="3ocgh0llhr757">
              <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-2.5 break-all transition-colors hover:text-teal-light" data-id="element-326" data-mp="3oczo179lsb4g">
                <MailIcon className="h-4 w-4 shrink-0 text-teal-light" data-id="element-327" data-mp="2agomxepfekgy" />
                {CONTACT.email}
              </a>
            </li>
            <li className="flex items-start gap-2.5" data-id="element-328" data-mp="21mth04ghcq09">
              <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal-light" data-id="element-329" data-mp="21nl9v7ip09mu" />
              <span data-id="element-330" data-mp="1woi93z9qwpko">{CONTACT.address}</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/15" data-id="element-331" data-mp="2te99gf4px6ye">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-5 py-6 text-xs text-white/60 sm:flex-row sm:items-center sm:justify-between sm:px-8" data-id="element-332" data-mp="2tbvfyapos2sy">
          <p data-id="element-333" data-mp="2kc8h9wocdb3l">
            © {new Date().getFullYear()} JAG Medical Solutions. All rights
            reserved.
          </p>
          <p data-id="element-334" data-mp="2fdow3yhko3ca">Therapeutic modalities, matched to your practice.</p>
        </div>
      </div>
    </footer>;
}